module.exports = __webpack_public_path__ + "3b9ae349d73e12b9873061688e356fd4.jpg";